import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../shared";
import Carousel from "react-elastic-carousel";

const DoctorReview = () => {
  const [review, setReview] = useState({});
  const { id } = useParams();
  useEffect(() => {
    const fetchReview = async () => {
      const response = await axios.get("review/");

      //filtering data based on doctor id
      const filteredValues = Object.values(response.data).filter((value) => {
        return (
          value.to === "Doctor" &&
          value.doctor_review[0].doctor_id.user === Number(id)
        );
      });

      setReview(filteredValues);
    };
    fetchReview();
  }, []);

  return (
    <div className="text-center bg-light p-4 mx-md-5 mx-3">
      <h5 className="mb-4">What Patient Says?</h5>
      <div
        className={`row row-cols-${
          review.length === 1 ? "1" : review.length === 2 ? "2" : "3"
        } justify-content-evenly`}
        style={{ gap: 5 + "rem" }}
      >
        {review.length > 0 ? (
          <Carousel
            itemsToShow={3}
            pagination={true}
            breakPoints={[
              { width: 1, itemsToShow: 1 },
              { width: 550, itemsToShow: 2 },
              { width: 850, itemsToShow: 3 },
            ]}
          >
            {review.map((review, i) => (
              <div className="col w-25" key={i}>
                <img
                  src={review.review_by.user_detail.user_image}
                  className="rounded-circle"
                  height={50}
                  alt="user"
                />
                <p className="m-0">{review?.description}</p>
                <p className="text-end">
                  - {review?.review_by.user_detail.name}
                </p>
              </div>
            ))}
          </Carousel>
        ) : (
          <p>No Reviews.</p>
        )}
      </div>
      <p className="text-end m-0 mt-4">
        Provide us your genuine feedback. <a href="/give/review">Review</a>
      </p>
    </div>
  );
};

export default DoctorReview;
